import React from "react";

import { Link } from "src/components/Link";
import { LinkAppearance } from "src/styles/link";

export const EmailPrivacy: React.FCC = () => {
  return (
    <Link
      data-tname="emailPrivacy"
      to="mailto:privacy@every.org"
      appearance={LinkAppearance.HYPERLINK}
    >
      privacy@every.org
    </Link>
  );
};
